import { render, staticRenderFns } from "./FreeText.vue?vue&type=template&id=9623e218&scoped=true&"
import script from "./FreeText.vue?vue&type=script&lang=js&"
export * from "./FreeText.vue?vue&type=script&lang=js&"
import style0 from "./FreeText.vue?vue&type=style&index=0&id=9623e218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9623e218",
  null
  
)

/* custom blocks */
import block0 from "./FreeText.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports